
export const getAuth = state => state.mailtop.auth.data;
export const isLoadingAuth = state => state.mailtop.auth.loading;
export const isLoadingLists = state => state.mailtop.lists.loading;
export const getLists = state => state.mailtop.lists.data || [];
export const getListsError = state => state.mailtop.lists.error;
export const isLoadingRejections = email => state => ( state.mailtop.rejections[ email ] || {} ).loading;
export const getRejections = email => state => ( state.mailtop.rejections[ email ] || {} ).data;
